import { Link } from '@tanstack/react-router';
import type { ComponentProps } from 'react';
import { Button } from '../primitives/button';

export type FeedbackAction = { label: string; to?: string; onClick?: () => void };

// The one action of an Alert or an EmptyState: a link when it has a route, else a button; both look like a button
// (design system §5).
export function ActionButton({
  action,
  variant,
}: {
  action: FeedbackAction;
  variant?: ComponentProps<typeof Button>['variant'];
}) {
  if (action.to === undefined) {
    return (
      <Button variant={variant} onClick={action.onClick}>
        {action.label}
      </Button>
    );
  }
  return (
    <Button variant={variant} asChild>
      <Link to={action.to} onClick={action.onClick}>
        {action.label}
      </Link>
    </Button>
  );
}
